import { EyeOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button, Grid, Tooltip } from 'antd';
import React from 'react';

const { useBreakpoint } = Grid;

interface PreviewButtonProps {
  onClick: (e: React.MouseEvent) => void;
  tooltip?: string;
  size?: 'small' | 'middle' | 'large';
  iconOnly?: boolean;
}

export const PreviewButton: React.FC<PreviewButtonProps> = ({
  onClick,
  tooltip = 'Preview',
  size,
  iconOnly = false,
}) => {
  const screens = useBreakpoint();

  return (
    <Tooltip title={tooltip}>
      <Button
        size={size}
        icon={<EyeOutlined />}
        onClick={onClick}
      >
        {!iconOnly && screens.md ? L('Preview') : null}
      </Button>
    </Tooltip>
  );
};
